import React from 'react';

const AsyncTimeSlotList = React.lazy(() => import('./ListContainer'));

export const TimeSlotList = () => {
  return <AsyncTimeSlotList />;
};
